<template>
  <div class="row mb-3" v-if="activeTab === RETAILER_REGISTER_STEP.COMPANY_ACTIVITY">
    <div class="col-md-12 mb-1">
      <label class="col-form-label"
        >{{ $t('views.retailer.users.register.city') }}/{{ $t('views.retailer.users.register.county') }}</label
      >
      <div>{{ user.retailer.address.city.name }}/{{ user.retailer.address.county.name }}</div>
    </div>
    <div class="col-md-12 mb-1">
      <label class="col-form-label">{{ $t('views.retailer.users.register.street') }}</label>
      <base-multiselect
        v-model="neighborhood"
        :placeholder="$t('views.retailer.users.register.search_or_select_street')"
        :selectedLabel="$t('shared.forms.multiselect-selected-label-selected')"
        label="name"
        track-by="id"
        :options="neighborhoods"
        :multiple="false"
        :taggable="false"
        :loading="neighborhoodIsLoading"
        :disabled="neighborhoodIsLoading"
        :class="validationStatuses(v$.retailerAddress.neighborhood_id)"
        @select="$event => onSelectNeighborhood($event)"
        @open="formClickSendEvent"
        @close="formClickSendEvent"
      ></base-multiselect>
      <template v-if="v$.retailerAddress.neighborhood_id.$error">
        <div v-if="v$.retailerAddress.neighborhood_id.required" class="invalid-feedback">
          {{
            $t('shared.validations.required', {
              field: $t('views.retailer.users.register.street')
            })
          }}
        </div>
      </template>
    </div>
    <div class="col-md-12 mb-1">
      <label class="col-form-label">{{ $t('views.retailer.users.register.address') }}</label>
      <base-input
        v-model="retailerAddress.street"
        type="text"
        :placeholder="$t('views.retailer.users.register.address_placeholder_text')"
        :class="validationStatuses(v$.retailerAddress.street)"
        @blur="v$.retailerAddress.street.$touch()"
        @focus="v$.retailerAddress.street.$reset()"
        :invalid="v$.retailerAddress.street.$error"
        :error-messages="retailerAddressStreetErrorMessages"
        tabindex="5"
        @click="formClickSendEvent"
      />
    </div>
    <questions-card ref="questions" v-if="questions.length" :questions="questions" />
  </div>
</template>
<script>
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'

import { event } from 'vue-gtag'

import store from '@/store/store'

import { addressMixin } from '@/mixins/addressMixin'
import { validationMixin } from '@/mixins/validationMixin'

import QuestionService from '@/services/retailer/QuestionService.js'
import { errorMessage } from '@/utilities/helpers.js'

import { errorMessageWithParams } from '@/utilities/validationErrorMessage'

import { RETAILER_REGISTER_STEP } from '@/constants/retailerRegisterStep'

import BaseInput from '@/components/BaseInput'
import BaseMultiselect from '@/components/BaseMultiselect'
import QuestionsCard from '@/views/retailer/users/components/registerComponents/questionsCard'

export default {
  name: 'CompanyActivityTab',
  props: {
    activeTab: {
      type: Number,
      required: true
    },
    user: {
      type: Object,
      default: null
    }
  },
  components: {
    QuestionsCard,
    BaseInput,
    BaseMultiselect
  },
  mixins: [addressMixin, validationMixin],
  data() {
    return {
      v$: useVuelidate(),
      RETAILER_REGISTER_STEP: RETAILER_REGISTER_STEP,
      retailerAddress: {},
      questions: []
    }
  },
  validations() {
    return {
      retailerAddress: {
        street: { required, $lazy: true },
        neighborhood_id: { required }
      }
    }
  },
  computed: {
    retailerAddressStreetErrorMessages() {
      return errorMessageWithParams(this.v$.retailerAddress.street, 'views.retailer.users.register.address')
    }
  },
  methods: {
    formClickSendEvent() {
      event('form_actions', {
        event_action: 'form_clicked',
        form_name: 'Tarfin Yetkili Satış Noktası Kayıt'
      })
    },
    getQuestions() {
      QuestionService.getQuestions()
        .then(response => {
          this.questions = response.data
        })
        .catch(err => {
          const notifications = {
            type: 'danger',
            message:
              this.$t('views.retailer.users.register.can_not_get_company_register_questions_error') + errorMessage(err)
          }
          store.dispatch('notification/add', notifications, {
            root: true
          })
        })
    },
    validateRetailerAddress() {
      this.v$.retailerUser.$touch()

      if (this.v$.retailerAddress.$error) {
        return false
      }
      return true
    },
    validateQuestionAnswer() {
      return this.$refs.questions.v$.$invalid
    },

    onSelectNeighborhood(val) {
      this.district = val.district
    }
  },
  watch: {
    district(obj) {
      this.retailerAddress.district_id = obj.id
    },
    neighborhood(obj) {
      this.retailerAddress.neighborhood_id = obj.id
    },
    activeTab(tab) {
      if (tab === RETAILER_REGISTER_STEP.COMPANY_ACTIVITY) {
        this.getNeighborhoods(this.user.retailer.address.county)
      }
    }
  },
  mounted() {
    this.retailerAddress = {
      street: '',
      district_id: null,
      neighborhood_id: null
    }
  },
  created() {
    this.getQuestions()
    if (this.user) {
      this.getNeighborhoods(this.user.retailer.address.county)
    }
  }
}
</script>
<style lang="scss" scoped></style>
